/* eslint-disable react/prefer-es6-class, react/sort-comp, quote-props, no-param-reassign */
import classnames from 'classnames';
import React from 'react';

import { t } from 'es6/services/localization';
import { humanizedTime } from 'es6/helpers/time';

const StudyTime = React.createClass({
  displayName: 'StudyTime',

  propTypes: {
    iKnowCumulatives: React.PropTypes.object,
  },

  render() {
    const iKnowCumulatives = this.props.iKnowCumulatives;
    const className = classnames('study-time', { 'waiting': !iKnowCumulatives });

    let items = null;
    let sentences = null;
    let total = null;

    if (iKnowCumulatives) {
      items = iKnowCumulatives.getItemsTotalTime();
      sentences = iKnowCumulatives.getSentencesTotalTime();
      total = iKnowCumulatives.getTotalTime();
    }

    return (
      <div className={className}>
        <header className="content-details">
          <div className="details-primary alone">{t('study-time.header')}</div>
        </header>

        <div className="content-primary">
          <ul className="content-list">
            {this._renderStat('total', t('study-time.total'), total)}
            {this._renderStat('items', t('study-time.items'), items)}
            {this._renderStat('sentences', t('study-time.sentences'), sentences)}
          </ul>
        </div>
      </div>
    );
  },

  _renderStat(type, primary, secondary) {
    // Use a placeholder for secondary if nothing is specified.
    secondary = secondary === null ? '-' : humanizedTime(secondary / 1000);

    // Because there is actually HTML in the string, it needs to be rendered as HTML.
    return (
      <li className={`list-item ${type}`}>
        <div className="primary">{primary}</div>
        <div className="secondary" dangerouslySetInnerHTML={{ __html: secondary }} />
      </li>
    );
  },
});

export default StudyTime;
